import {defineStore } from 'pinia';
import apiClient from '@/api/apiClient';
import Cookies from 'js-cookie';
import { useMenuStore } from '@/stores/menu';
import { useUserStore } from '@/stores/user';
import authService from '@/service/auth.service';

import { useVeterinariaStore } from '@/stores/veterinaria';

export const useAuthStore = defineStore('auth', {
    state: () => ({ 
        isAuthenticated: !!Cookies.get('isAuthenticated'),
        type_user: !!Cookies.get('type_user'),
    }),
    actions: {
        setAuthenticated(status) {
            Cookies.set('isAuthenticated', status);
            this.isAuthenticated = status;
        },
        setTypeUser(type) {
            Cookies.set('type_user', type);
            this.type_user = type;
        },
        async login(credentials) {
            try {
                // Forzar false antes del login para que el watch siempre detecte el cambio a true,
                // incluso si localStorage tenía isAuthenticated: true de una sesión anterior expirada
                this.isAuthenticated = false;
                const menuStore = useMenuStore();
                const userStore = useUserStore();

                const response = await apiClient.post('/login/start', credentials);
                
                if (!response.data.data.is_admin) {
                    const veterinariaStore = useVeterinariaStore();
                    console.info('paso por aqui');
                    const veterinaria = await authService.setVeterinaria(response.data.data.uid);
                    console.log('Veterinaria data:', veterinaria);
                    veterinariaStore.setVeterinaria(veterinaria);
                }
                
                this.setAuthenticated(true);
        
                userStore.setUid(response.data.data.uid);

                menuStore.deleteMenu();
                menuStore.setTypeMenu(response.data.data.type_user);
                menuStore.setMenu(response.data.data.menu);
                menuStore.setMenuAux(response.data.data.menu);
                menuStore.setDynamicRoutes();

                this.setTypeUser(response.data.data.type_user);

                return response.data.data.type_user;
            } catch (error) {
                console.log('Error auth():',error);
                throw error;
            }
        },
        async logout() {
            try {
                const menuStore = useMenuStore();
                
                this.setAuthenticated(false);
                Cookies.remove('isAuthenticated');
                Cookies.remove('sucursal_sponsored');
                localStorage.removeItem("veterinariaStore");
                 localStorage.removeItem("sucursal_sponsored");
                menuStore.setDynamicRoutes();
                menuStore.deleteMenu();
            } catch (error) {
                console.error('Error logging out:', error);
            }
        },
    },
    persist: {
        storage: localStorage,
    }
  });